// extracted by mini-css-extract-plugin
module.exports = {"resourceThumbnailContainer":"slider_resource_item-module__resourceThumbnailContainer___1QmoV"};